var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sidebar-container" },
    [
      _c(
        "div",
        {
          staticClass: "sidebar",
          class: [{ sidebar_show: _vm.is_sidebar_show }],
        },
        [
          _vm.$screen.mobile
            ? _c(
                "button",
                {
                  staticClass: "sidebar__toggle-button",
                  on: { click: _vm.toggle_sidebar_show },
                },
                [
                  _c("span", { staticClass: "sidebar__toggle-button__text" }, [
                    _vm._v("❯"),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sidebar__item",
              on: {
                click: function ($event) {
                  return _vm.clickWelfare(0)
                },
              },
            },
            [
              _c("c-picture", {
                staticClass: "sidebar__item__icon light",
                attrs: {
                  src: require("@/assets/icons/event-icon.png"),
                  width: "130%",
                  ratio: "76:77",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.GobalInfo.GroupLink
            ? _c(
                "a",
                {
                  staticClass: "sidebar__item",
                  attrs: { href: _vm.GobalInfo.GroupLink, target: "_blank" },
                },
                [
                  _c("c-picture", {
                    staticClass: "sidebar__item__icon",
                    attrs: {
                      src: require("@/assets/images/icon/group.png"),
                      width: "70%",
                      ratio: "24:24",
                    },
                  }),
                  _c("span", { staticClass: "sidebar__item__label" }, [
                    _vm._v("一键加群"),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.GobalInfo.ServiceLink
            ? _c(
                "a",
                {
                  staticClass: "sidebar__item",
                  attrs: { href: _vm.GobalInfo.ServiceLink, target: "_blank" },
                },
                [
                  _c("c-picture", {
                    staticClass: "sidebar__item__icon",
                    attrs: {
                      src: require("@/assets/images/icon/service.png"),
                      width: "70%",
                      ratio: "24:24",
                    },
                  }),
                  _c("span", { staticClass: "sidebar__item__label" }, [
                    _vm._v("咨询客服"),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      !_vm.$screen.mobile && false
        ? _c(
            "a",
            {
              staticClass: "goto-top",
              attrs: { href: "#topflag", title: "返回顶部" },
            },
            [
              _c("i", {
                staticClass: "ivu-icon ivu-icon-md-arrow-dropup-circle",
                staticStyle: { "font-size": "25px" },
              }),
              _c("span", { staticClass: "goto-top__label" }, [_vm._v("TOP")]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal",
            "footer-hide": "",
            width: "600rem",
            closable: false,
          },
          model: {
            value: _vm.exchange.is_modal_show,
            callback: function ($$v) {
              _vm.$set(_vm.exchange, "is_modal_show", $$v)
            },
            expression: "exchange.is_modal_show",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              staticClass: "sign-up",
              attrs: { title: "兑换", has_close_button: "" },
              on: {
                close_button_click: function () {
                  _vm.exchange.is_modal_show = false
                },
              },
            },
            [
              _c("div", { staticClass: "sign-up__content" }, [
                _c("label", { staticClass: "sign-up__field" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.exchange.exchangeCode,
                        expression: "exchange.exchangeCode",
                      },
                    ],
                    staticClass: "sign-up__field__input",
                    attrs: {
                      type: "text",
                      placeholder: "请输入兑换码",
                      autocomplete: "off",
                    },
                    domProps: { value: _vm.exchange.exchangeCode },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.exchange,
                          "exchangeCode",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("label", { staticClass: "sign-up__field" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.exchange.otp,
                        expression: "exchange.otp",
                      },
                    ],
                    staticClass: "sign-up__field__input",
                    attrs: {
                      type: "text",
                      placeholder: "请输入验证码",
                      autocomplete: "off",
                    },
                    domProps: { value: _vm.exchange.otp },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.exchange, "otp", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "submit-button",
                    staticStyle: { width: "100%", "margin-top": "10px" },
                    on: {
                      click: function ($event) {
                        return _vm.doExchange()
                      },
                    },
                  },
                  [_vm._v(" 确认兑换")]
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }